export default "__VITE_ASSET__TpjaV2KG__"